var FcOutlinedTextareaModule = /** @class */ (function () {
    function FcOutlinedTextareaModule() {
    }
    return FcOutlinedTextareaModule;
}());
export { FcOutlinedTextareaModule };
